import { defineAbility } from "@casl/ability";
import { FEATURES, MODULES, SERVICES, SIDEMENU_ITEMS } from "./permissions";

export function defineAbilitiesFor(user) {
  const { module, Service } = user || {};
  return defineAbility((can) => {

    // 1. Global Super Admin / Admin with access to ALL modules and services
    if (module === MODULES.ALL && Service === SERVICES.ALL) {
      can("manage", "all");
      return;
    }

    // 2. Module-specific permissions
    switch (module) {
      case MODULES.INSPECTION_APP:
        can("view", SIDEMENU_ITEMS.INSPECTION);
        break;

      case MODULES.RESORT_BOOKING:
        can("view", SIDEMENU_ITEMS.RESORT);
        break;

      case MODULES.MAIN_SITE:
        can("view", SIDEMENU_ITEMS.MAIN_SITE);
        break;

      case MODULES.FLEET_MANAGEMENT:
        can("view", SIDEMENU_ITEMS.FLEET_MANAGEMENT);
        break;

      case MODULES.E_TICKETING:
        handleETicketingPermissions(can, user);
        break;

      default:
        break;
    }
  });
}


// ------------------------------
// ✔ E-Ticketing Permissions
// ------------------------------
function handleETicketingPermissions(can, user) {
  const { roles, service_id } = user;

  // Service-Based E-Ticketing Users
  if (service_id && roles) {
    if (roles === "Admin") {
      can("manage", service_id);
      can("manage", FEATURES.ROUTE);
      can("manage", FEATURES.ROUTE_PRICE);
      can("manage", FEATURES.ROUTE_TIMING);
      can("manage", FEATURES.CMS);
    } else if (roles === "Sub Admin") {
      can("read", service_id);
      can("create", FEATURES.ROUTE);
      can("create", FEATURES.ROUTE_PRICE);
      can("create", FEATURES.ROUTE_TIMING);
    } else if (roles === "Manager") {
      can("read", service_id);
      can("read", FEATURES.ROUTE);
      can("read", FEATURES.ROUTE_PRICE);
      can("read", FEATURES.ROUTE_TIMING);
    }

    // Service-to-menu mapping using service_id
    const ETICKETING_SERVICE_TO_MENU = {
      1: SIDEMENU_ITEMS.CHAIRLIFT_AND_CABLE_CAR,  // Patriata Chairlift
      2: SIDEMENU_ITEMS.SIGHTSEEING,              // Sightseeing
      3: SIDEMENU_ITEMS.BOATING,                  // Boating
      4: null,                                     // Parking (no menu item)
      5: null,                                     // Golf Cart (no menu item)
      6: SIDEMENU_ITEMS.SOFTWHEEL_TRAIN,          // Softwheel Train
      7: SIDEMENU_ITEMS.E_TICKETING,              // General e-ticketing
    };

    const ETICKETING_SERVICE_TO_FEATURE = {
      1: [FEATURES.ADD_PEOPLE_COUNT]
    }

    const menu = ETICKETING_SERVICE_TO_MENU[service_id];

    const features = ETICKETING_SERVICE_TO_FEATURE[service_id] || [];
    features.forEach(feature => can("manage", feature));
    
    if (menu) {
      can("view", menu);
    }
  }
}
